import React, { createContext, useContext, useEffect, useState } from "react";

const LocationContext = createContext();

const DEFAULT_CITY = "Delhi";

/* Simple coordinate → city mapping (extend later) */
const detectCityFromCoords = (lat, lng) => {
  // Rough India-based logic (safe fallback)
  if (lat > 26 && lat < 29 && lng > 79 && lng < 81) return "Delhi";
  if (lat > 26 && lat < 27 && lng > 80 && lng < 81) return "Lucknow";
  if (lat > 25 && lat < 26 && lng > 82 && lng < 83) return "Varanasi";
  if (lat > 26 && lat < 27 && lng > 80 && lng < 81) return "Kanpur";

  return DEFAULT_CITY;
};

export const LocationProvider = ({ children }) => {
  const [city, setCity] = useState(() => {
    return localStorage.getItem("ng_city") || DEFAULT_CITY;
  });

  /* AUTO DETECT LOCATION – ONLY IF NOT SAVED */
  useEffect(() => {
    const savedCity = localStorage.getItem("ng_city");
    if (savedCity) return; // 👈 user already chose city

    if (!navigator.geolocation) return;

    navigator.geolocation.getCurrentPosition(
      (position) => {
        const { latitude, longitude } = position.coords;
        const detectedCity = detectCityFromCoords(latitude, longitude);
        setCity(detectedCity);
        localStorage.setItem("ng_city", detectedCity);
      },
      () => {
        // Permission denied → keep default
        setCity(DEFAULT_CITY);
      },
      { timeout: 8000 },
    );
  }, []);

  /* Sync city to localStorage (manual changes) */
  useEffect(() => {
    localStorage.setItem("ng_city", city);
  }, [city]);

  return (
    <LocationContext.Provider value={{ city, setCity }}>
      {children}
    </LocationContext.Provider>
  );
};

export const useLocationContext = () => useContext(LocationContext);
